import { type ReactElement } from 'react';
import { MenuHamburgerIcon } from '@navikt/aksel-icons';
import { useTranslation } from 'react-i18next';
import { Button } from '@digdir/designsystemet-react';
import { LogoHeader } from '../../LogoHeader';
import { NotificationBell } from '../../NotificationCenter/NotificationBell';
import classes from './MenuHeader.module.css';

type MenuHeaderProps = {
  toggleMenu: () => void;
  isOpen: boolean;
  panelId: string;
};

export const MenuHeader = ({ toggleMenu, isOpen, panelId }: MenuHeaderProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <LogoHeader />
      <div className={classes.actions}>
        <NotificationBell />
        <Button
          variant="tertiary"
          data-color="neutral"
          onClick={toggleMenu}
          aria-expanded={isOpen}
          aria-controls={panelId}
          aria-haspopup="dialog"
        >
          <MenuHamburgerIcon aria-hidden />
          {t('mobileMenu.menu')}
        </Button>
      </div>
    </div>
  );
};
